import { orderIncomingTeams } from '../utils';

import { FragmentType } from './types';

export const competitions_event: FragmentType<'competitions_event'> = {
  fields: {
    playing_teams: orderIncomingTeams(),
  },
};
